export default "__VITE_ASSET__GPg$CYjQ__"